// API 路径配置
export const API_PATHS = {
  // 认证相关
  AUTH: {
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    LOGOUT: '/auth/logout'
  },
  
  // 员工相关
  EMPLOYEE: {
    LIST: '/employees',
    DETAIL: '/employees/:id',
    CREATE: '/employees',
    UPDATE: '/employees/:id',
    DELETE: '/employees/:id'
  },

  // 部门相关  
  DEPARTMENT: {
    LIST: '/departments',
    DETAIL: '/departments/:id',
    CREATE: '/departments',
    UPDATE: '/departments/:id',
    DELETE: '/departments/:id'
  },

  USER: {
    GET_LOGIN_INFO: '/user/getLoginInfo'  // 获取用户信息接口
  },

  REPORT: {
    LIST: '/ai-report/task/nologin/listTask',
    START: '/ai-report/task/nologin/startTask',
    DETAIL: '/ai-report/task/nologin/taskDetail',
    MOBAN_LIST: '/ai-report/task/nologin/listMoban',
    RERUN_QUESTION: '/ai-report/task/nologin/rerunQuestion',
    USE_RERUN: '/ai-report/task/nologin/useRerun',
    ADD_QUESTION: '/ai-report/task/nologin/addQuestionList',
    CREATE_TEMPLATE: '/ai-report/moban/nologin/createFromTask'
  },

  AI: {
    TYPE_LIST: '/filegpt/t_ai/nologin/aiTypeList'
  }
}

// API 请求方法
export const REQUEST_METHODS = {
  GET: 'get',
  POST: 'post',
  PUT: 'put',
  DELETE: 'delete'
}

// 环境配置
export const API_CONFIG = {
  // 直接使用环境变量
  BASE_URL: process.env.VUE_APP_API_BASE_URL,
  
  // 超时时间
  TIMEOUT: 15000,
  
  // 是否启用 Mock
  USE_MOCK: process.env.VUE_APP_USE_MOCK === 'true'
}

// 响应码配置
export const RESULT_CODE = {
  SUCCESS: 1  // 成功状态码为1
} 